import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class ExperienceEditService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }


	loadExperience(token, ID) {

		return this.http
		.get(this.apiUrl + "experiences/v1/getexperience/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	editExperience(token, experience: any) {

		return this.http
		.put(this.apiUrl + "experiences/v1/updateexperience", experience, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/experience/service/experience-edit/experience-edit.service.ts